import Util from './forecast-app/shared/util/util';

const tracking = {
	trackPage(page_name, insightComponents = null, columns = null, additionalProperties = null) {
		try {
			let eventProperties = {
				'page name': page_name,
			};
			if (insightComponents) {
				eventProperties.insightComponents = insightComponents;
			}
			if (columns) {
				eventProperties.columns = columns;
			}
			if (additionalProperties && typeof additionalProperties === 'object') {
				eventProperties = Object.assign(additionalProperties, eventProperties);
			}
			Util.sessionStorageSetItem('amplitude_page', page_name);
			if (process.env.CIRCLE_BRANCH !== 'production') {
				// eslint-disable-next-line no-console
				console.log('TRACKING: Page Viewed', eventProperties);
			}

			if (window.userpilot) {
				window.userpilot.track('Page Viewed', eventProperties);
			}

			const forecast_user = localStorage.getItem('forecast_user');
			if (forecast_user !== 'true' || true) {
				// Hubspot tracking
				const _hsq = window._hsq || [];
				_hsq.push(['setPath', '/' + page_name]);
				_hsq.push(['trackPageView']);
			}

			if (window.amplitude) {
				window.amplitude.getInstance().logEvent('Page Viewed', eventProperties);
			}

			if (window.gtag) {
				window.gtag('config', 'UA-35386755-4', {
					page_title: page_name,
					page_path: window.location.pathname,
				});
			}
		} catch (e) {
			// eslint-disable-next-line no-console
			console.log(e);
		}
	},
	trackEvent(event_name, options = null) {
		try {
			const page_name = sessionStorage.getItem('amplitude_page');
			const task_open = sessionStorage.getItem('amplitude_task_open') === 'true';

			if (options !== null) {
				options.page = page_name;
				options.task_modal_open = task_open;
			} else {
				options = {page: page_name, task_modal_open: task_open};
			}

			if (process.env.CIRCLE_BRANCH !== 'production') {
				// eslint-disable-next-line no-console
				console.log('TRACKING: ' + event_name, options);
			}

			const forecast_user = localStorage.getItem('forecast_user');
			if (forecast_user !== 'true') {
				// Hubspot tracking
				const _hsq = window._hsq || [];
				_hsq.push([
					'trackEvent',
					{
						id: `App ${event_name}`,
					},
				]);
			}

			if (window.amplitude) {
				window.amplitude.getInstance().logEvent(event_name, options);
			}

			if (window.userpilot) {
				window.userpilot.track(event_name, options);
			}

			if (window.gtag) {
				window.gtag('event', event_name);
			}
		} catch (e) {
			// eslint-disable-next-line no-console
			console.log(e);
		}
	},
	registerSuperProperty(key, value) {
		if (key === '_TaskModalOpen') {
			Util.sessionStorageSetItem('amplitude_task_open', value);
		}
	},
	logout() {
		// Hubspot remove cookie
		document.cookie = 'hubspotutk=; Max-Age=-99999999;domain=.forecast.it;';
		document.cookie = '__hstc=; Max-Age=-99999999;domain=.forecast.it;';
	},
};

tracking.trackElementClicked = (clicked, options = null) => {
	if (clicked) {
		tracking.trackEvent(
			'Element clicked',
			Object.assign(
				{
					clicked,
				},
				options || {}
			)
		);
	}
};

tracking.trackElementHovered = (hovered, options = null) => {
	if (hovered) {
		tracking.trackEvent(
			'Element hovered',
			Object.assign(
				{
					hovered,
				},
				options || {}
			)
		);
	}
};

tracking.trackToggleCollapse = (collapsed, id, options = null) => {
	tracking.trackEvent(
		'Toggled collapse',
		Object.assign(
			{
				element: id,
				collapsed,
			},
			options || {}
		)
	);
};

tracking.trackPageLeft = (page, options = null) => {
	if (page) {
		tracking.trackEvent(
			'Page left',
			Object.assign(
				{
					page,
				},
				options || {}
			)
		);
	}
};

tracking.trackPageAction = (action, options = null) => {
	if (action) {
		tracking.trackEvent(
			'Page action',
			Object.assign(
				{
					action,
				},
				options || {}
			)
		);
	}
};

tracking.trackPageLoad = (element, options = {}) => {
	if (element) {
		tracking.trackEvent(
			'Page load',
			Object.assign(
				{
					element,
				},
				options
			)
		);
	}
};

tracking.trackInfoTooltipShown = (helpIcon, placement = null) => {
	if (helpIcon) {
		const options = {
			'Help icon': helpIcon,
		};
		if (placement) {
			options.Placement = placement;
		}
		tracking.trackEvent('Info Tooltip shown', options);
	}
};

const optionVisitor = (option, callback, parentPath) => {
	const path = parentPath ? `${parentPath}.${option.name}` : option.name;

	callback(option, path);
	if (option.nestedOptions) {
		option.nestedOptions.forEach(nestedOption => {
			if (nestedOption !== undefined && nestedOption !== null) {
				optionVisitor(nestedOption, callback, path);
			}
		});
	}
};

const optionTraverser = (options, callback) => {
	const page_name = sessionStorage.getItem('amplitude_page');

	options.forEach(option => {
		if (option !== undefined && option !== null) {
			optionVisitor(option, callback, page_name);
		}
	});
};

tracking.trackEyeSelector = eyeOptions => {
	if (eyeOptions) {
		try {
			const shown = [];
			let eyeOptionsString = '';
			optionTraverser(eyeOptions, (option, path) => {
				if (option.checked) {
					shown.push(path);
					eyeOptionsString += `${option.name},`;
				}
			});

			tracking.trackEvent('Eye options selected', {
				Shown: shown,
				eyeOptions: eyeOptionsString,
				count: shown.length,
			});
		} catch (e) {
			// eslint-disable-next-line no-console
			console.warn('Suppress error, to not break the page because of tracking', e);
		}
	}
};

tracking.trackSectionAdded = sectionOptions => {
	if (sectionOptions) {
		tracking.trackEvent('Section added', sectionOptions);
	}
};

tracking.trackFilter = filterValues => {
	if (filterValues) {
		let spreadFilterValues = [];
		let nbFilter = 0;
		// Spread the values of the filter object into a single array of strings.
		Object.keys(filterValues).forEach(group => {
			const groupFilterValues = Object.keys(filterValues[group])
				.map(key => {
					nbFilter += filterValues[group][key].length;
					return filterValues[group][key].length > 0 ? group + 'Filter-' + key : null;
				})
				.filter(val => val !== null);
			spreadFilterValues = spreadFilterValues.concat(groupFilterValues);
		});

		const track = {filters: spreadFilterValues, nbFilterApplied: nbFilter};
		if (spreadFilterValues.length > 0) {
			tracking.trackEvent('Filters applied', track);
		}
	}
};

tracking.trackSurvey = options => {
	if (options) {
		tracking.trackEvent('Survey action', options);
	}
};

tracking.trackAIEvent = (event, model, selected = null, additionalOptions) => {
	if (event && model) {
		const options = {
			event,
			model,
			selected,
			additionalOptions,
		};
		tracking.trackEvent('AI Event', options);
	}
};

module.exports = tracking;
